export default __webpack_public_path__ + "static/media/tabebuya-4.8726883b.JPG";